<div class="grid">
    <div class="col-12">
        <div class="search-container">
            <p-accordion>
                <p-accordionTab header="{{ hrKey.hrCommon.queryCriteria | translate }}" [selected]="true">
                    <ng-content select="[hrAccordion]"></ng-content>
                </p-accordionTab>
            </p-accordion>
        </div>
    </div>
</div>
